import { Attention as AttentionIcon, Information as InformationIcon, Success as SuccessIcon, Warning as WarningIcon } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { CloseButton } from '../CloseButton/CloseButton';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import { applyVariations } from '../utils/utils';
const bannerColors = {
  green: {
    backgroundColor: 'secondary.base',
    color: 'text.lightest',
    icon: React.createElement(SuccessIcon, null)
  },
  lightGreen: {
    backgroundColor: 'secondary.light',
    color: 'secondary.dark',
    icon: React.createElement(SuccessIcon, null)
  },
  red: {
    backgroundColor: 'error.base',
    color: 'text.lightest',
    icon: React.createElement(WarningIcon, null)
  },
  lightRed: {
    backgroundColor: 'error.light',
    color: 'error.dark',
    icon: React.createElement(WarningIcon, null)
  },
  orange: {
    backgroundColor: 'alert.base',
    color: 'text.lightest',
    icon: React.createElement(AttentionIcon, null)
  },
  blue: {
    backgroundColor: 'primary.base',
    color: 'text.lightest',
    icon: React.createElement(InformationIcon, null)
  },
  lightBlue: {
    backgroundColor: 'primary.light',
    color: 'primary.dark',
    icon: React.createElement(InformationIcon, null)
  }
};
const StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Banner__StyledBox",
  componentId: "sc-1xoq14y-0"
})(["", ""], applyVariations('Banner'));
/**
 * @public
 */
export function Banner({
  bg,
  color = 'green',
  children,
  header,
  icon,
  onClose,
  showIcon = true,
  text,
  textAlign = 'left',
  ...props
}) {
  const bannerColor = bannerColors[!bg && color === 'green' ? color : bg] || {};
  const Icon = icon || bannerColor.icon;
  const finalColor = !bannerColor.color ? color : bannerColor.color;
  let finalHeader = null;
  if (header) {
    finalHeader = React.isValidElement(header) ? header : React.createElement(Text, {
      textStyle: 'display2'
    }, header);
  }
  return React.createElement(StyledBox, {
    ...props,
    textAlign: textAlign,
    bg: bannerColor.backgroundColor || bg,
    color: finalColor
  }, React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }, !!Icon && !!showIcon && React.cloneElement(Icon, {
    mr: 2,
    size: 24,
    mt: '-2px'
  }), React.createElement(Box, {
    textAlign: textAlign,
    width: 1
  }, finalHeader, React.createElement(Text.span, {
    fontSize: 1
  }, text), children), !!onClose && React.createElement(CloseButton, {
    onClick: onClose,
    ml: 2,
    size: 24,
    title: 'close',
    mt: '-2px'
  })));
}